import React, { useRef, useState } from "react";
import { testIdProps } from "../../../../../utils/testIdProps";
import ErrorMessage from "../../../../../Shared/error-message/errorMessage";
import Styles from "../../Shared/sharedStyles.module.scss";
import InputField from "../../Shared/inputField/inputField";
import {
  buttonStyles,
  StyledButton,
} from "../../../../../Shared/button/button";
import { validPhoneNumber } from "../../../../../utils/validation";

function UpiAdvancePopup({ handleResponse }: any) {
  const errorObject = {
    mobileNumberError: false,
    consentError: false,
  };

  const [error, setError] = useState({ ...errorObject });
  const [isChecked, setIsChecked] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [loading, setLoading] = useState(false);

  const mobileNumberRef = useRef<any>("");

  function isValid() {
    if (validPhoneNumber(mobileNumberRef.current.value.trim())) {
      setError(errorObject);
      return setIsDisabled(false);
    }
    setError(() => ({
      ...error,
      mobileNumberError: true,
    }));
    return setIsDisabled(true);
  }

  function handleCheck() {
    const mobileNumber = mobileNumberRef.current.value;
    const consent = isChecked === true ? "Y" : "N";

    if (!isChecked) {
      setError(() => ({
        ...error,
        consentError: true,
      }));
      return false;
    }
    setLoading(true);
    handleResponse({ mobileNumber, consent }, setLoading);
  }

  return (
    <div className={`${Styles.content}`}>
      <div className={`${Styles.infoForm} pl-2`}>
        <hr />
        <p className="mt-2">Fill in the below details to run verification</p>
        <div className="d-flex flex-column">
          <div className="d-flex flex-column mb-4 ">
            <label className={`${Styles.label} flex-grow-1`}>
              Mobile Number
            </label>
            <InputField
              id="id-input-mobile-number"
              onChange={isValid}
              maxLength={10}
              inputRef={mobileNumberRef}
              isError={error.mobileNumberError}
              purpose="forPan"
            />
            {error.mobileNumberError && (
              <ErrorMessage>Please enter a valid mobile number</ErrorMessage>
            )}
          </div>
          <div className="pt-4 pl-4 pb-4 mt-4 d-flex flex-column">
            <div className="d-flex align-items-center py-0 gap-2">
              <input {...testIdProps("consent-checkbox-upi-advance")}
                type="checkbox"
                className={`${Styles.formCheckInput} `}
                onChange={(e: any) => {
                  setIsChecked(e.target.checked);
                  isValid();
                }}
              />
              <p className={`${Styles.ackText} mb-0`}>
                I hereby agree, to let zoop.one verify my data for verification
              </p>
            </div>
            {error.consentError && (
              <ErrorMessage>Please provide consent!</ErrorMessage>
            )}
          </div>
          <div className={`${Styles.buttonGroup}`}>
            <StyledButton
              id="id-submit-button-upi-advance"
              hoverStyle={{ ...buttonStyles.primary.hover }}
              disabled={isDisabled}
              isLoading={loading}
              style={{ ...buttonStyles.primary.normal }}
              onClick={() => {
                setTimeout(() => setError({ ...errorObject }), 2000);
                handleCheck();
              }}
            >
              Run Verification
            </StyledButton>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UpiAdvancePopup;
